export default "__VITE_ASSET__5ec40192__"